import moment from 'moment'
import _ from 'lodash'

export function mapBillingForFront(data) {
  const billArray = []
  data.forEach((bill) => {
    billArray.push(formatOneBill(bill))
  })
  return billArray
}

function formatOneBill(data) {
  let momentStartExtracted = moment(data.startTime, 'YYYY/MM/DD HH:mm')
  const startDateFormatted = momentStartExtracted.format('DD/MM/YYYY - HH:mm')
  const momentEndExtracted = moment(data.endTime, 'YYYY/MM/DD HH:mm')

  let tipFees = data.billingRules ? data.billingRules.join(', ') : ''
  return {
    gameName: data.gameName,
    idGame: data.idGame,
    formattedStartdateTime: startDateFormatted,
    rawStartDateTime: data.startTime,
    duration: data.duration,
    teamCount: _.get(data, 'teamCount.teamCountInDb', _.get(data, 'teamCount.teamCreatedCount', data.teamCount)),
    price: data.billing ? data.billing.price : data.price,
    priceStr: data.billing ? data.billing.priceStr : '',
    tipDuration: formatString(momentStartExtracted, momentEndExtracted, data.autoStop),
    tipFees: data.billing && data.billing.priceStr ? data.billing.priceStr : tipFees,
    overFees: data.overFeesCategory,
    invoiceStatus: data.invoiceStatus
  }
}

function formatString(moment1, moment2, autoStop) {
  const stringAutostop = autoStop ? ' (autostop)' : ''
  return `${moment1.format('HH:mm')} - ${moment2.format('HH:mm')}${stringAutostop}`
}

export default {
  mapBillingForFront
}
